module.exports = __webpack_public_path__ + "fonts/iconfont.32408eb3.woff2";